<template>
<v-container fluid>
    <h1>Novidades</h1>
    <v-tabs light background-color="white" show-arrows height="auto">
        <v-tabs-slider color="primary lighten-3"></v-tabs-slider>
        <v-tab v-for="(product,i) in products" :key="i">
            
          <v-card class="mx-auto product-card">
        
            <v-img class="white--text align-end" width="100%" :src="product.photos[0]">
            </v-img>
  
            <v-card-subtitle class="pb-0">{{product.name}}</v-card-subtitle>
  
            <v-card-text class="text--primary">
              <div>{{product.brand}}</div>
            </v-card-text>
  
            <v-card-actions>
              <v-btn color="orange" text>Favoritar</v-btn>
              <v-btn color="orange" text>Comprar</v-btn>
            </v-card-actions>
      
          </v-card>
      </v-tab>
    </v-tabs>  
</v-container>
</template>

<style>
.product-card{margin:20px 0;}
</style>


<script>

  export default {
    name: 'ProductsCarousel',
    components:{
    },
    data(){
      return {
      }
    },
    methods:{
      getMoreProducts(){
        var opts = {'pg':0};
        this.$store.dispatch('getData',opts);
      },
    },
    computed:{
      products() {
        return this.$store.state.products;
      }
    },
    mounted(){
    },   
    created() {
    }
  }
</script>